import './Gear.scss';
import { ReactComponent as GearSvg } from './Gear.svg';


export function Gear() {
    return <div className='Gear'>
        <GearSvg />
    </div>
}